import { OperationParameter } from "@kanda-libs/openapi-io-ts-runtime";

export const tier: OperationParameter = {
  _tag: "FormParameter",
  explode: true,
  in: "query",
  name: "tier",
};
